import styled from "styled-components";
import RCTooltip from "@streeteasy/design-system/legacy/Tooltip";
import {
  TooltipContentWrapper,
  TooltipTriangle,
  Trigger
} from "@streeteasy/design-system/legacy/Tooltip/styled";
import { colors, RadioInput, typography } from "design-system";

export const QuestionContainer = styled.div`
  background-color: ${colors.GRAY_LIGHTEST};
  padding: 24px 16px;
  width: 100%;
`;

export const Text = styled(typography.Body)`
  margin-bottom: 16px;
`;

export const Answers = styled.div`
  margin-top: -8px;
`;

export const AnswerOption = styled(RadioInput)`
  margin-bottom: 16px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const Tooltip = styled(RCTooltip).attrs({
  position: "top",
  theme: "small",
  trigger: "click",
  width: "168px"
})`
  margin-left: 6px;
  vertical-align: baseline;

  ${Trigger} {
    color: ${colors.TEXT_SECONDARY};
  }

  ${TooltipContentWrapper} {
    background-color: ${colors.GRAY_LIGHTEST};
    padding: 16px;
    text-align: left;
  }

  ${TooltipTriangle} {
    &:before {
      color: ${colors.GRAY_LIGHTEST};
    }
  }
`;

export const ErrorText = styled(typography.Body)`
  color: ${colors.ERROR};
  margin-top: 8px;
`;

export const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

export const Dot = styled.div`
  background-color: ${props => (props.active ? colors.BRAND : colors.GRAY)};
  border-radius: 50%;
  height: 8px;
  margin-left: 8px;
  width: 8px;

  &:first-child {
    margin-left: 0;
  }
`;
